import { Fragment } from 'react'
import { Popover, Text } from '@leroy-merlin-br/backyard-react-ui'

import { Icon } from 'lmcv/components/Icon'

import { IconToolTip } from '../IconToolTip'
import * as S from './styled'

export function ToolTipInfo () {
  return (
    <S.TextBonus>
      <Icon name="cart_special" />
      <span>Bônus de clientes</span>{' '}
      <Popover
        title="Como funcionam os Bônus de Clientes?"
        content={
          <Fragment>
            <Text size="kilo">
              Os bônus de clientes são todos pontos que você ganha quando seus
              clientes realizam compras.
            </Text>
            <Text size="kilo">
              Durante um projeto você ganha <strong>10%</strong> de pontos pela
              compra de cada cliente.
            </Text>
            <Text size="kilo" noMargin>
              Você também pode ganhar bônus de clientes concluindo os
              <strong> Meus Objetivos</strong>.
            </Text>
          </Fragment>
        }
        placement="bottom"
      >
        <IconToolTip />
      </Popover>
    </S.TextBonus>
  )
}
